// extracted by mini-css-extract-plugin
export default {"page":"eU-z","cartModal":"fU-z","checkout":"gU-z","placeholder":"hU-z","account":"iU-z"};